/* AIVIQ homepage: »Find din espressomaskine«, six machines, four questions (sections/aiviq-home-finder.liquid).
   Rules and copy: pdp/research/quiz-r8.md. §2 the flow (one fork, two questions per branch, budget last), §3 the
   scoring, §4 the result card (one match, three reasons, one honest note, one alternative), §5 the budget chips
   (made from the live prices). Prices, stock, links and pictures come from the JSON the section prints. */
(function () {
  const root = document.querySelector('[data-af]');
  if (!root || root.dataset.afReady) return;
  root.dataset.afReady = '1';
  let DATA;
  try { DATA = JSON.parse(root.querySelector('[data-af-data]').textContent).machines; } catch (e) { return; }
  const quiz = root.querySelector('[data-af-quiz]');
  const NB = ' ';
  const kr = (ore) => Math.round(ore / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + NB + 'kr';
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const LADDER = { hands: ['core', 'brew', 'advanced', 'expert'], touch: ['lumina', 'aem'] };
  const ok = (k) => DATA[k] && DATA[k].ok && DATA[k].available !== false;
  const inPlay = (g) => LADDER[g].filter(ok);

  /* ---------- the questions (§2.2) ---------- */
  const Q = {
    q1: { title: 'Hur vill du göra kaffet?', opts: [
      ['touch', 'Med ett tryck', 'Maskinen maler, brygger och skummar mjölken åt dig.'],
      ['hands', 'Själv, som en barista', 'Du maler kaffet, trycker ner det och skummar mjölken.']],
      more: 'Med ett tryck gör maskinen hela koppen: den maler bönorna, brygger och skummar mjölken. Med en Aspire gör du den själv: kvarnen är inbyggd, och du trycker ner kaffet, brygger och skummar mjölken. Aspire-serien kan du prova hemma i 30 dagar.' },
    q2h: { title: 'Vad ska den göra?', opts: [
      ['espresso', 'Espresso och svart kaffe', 'Sällan med mjölk'],
      ['one', 'En mjölkdryck i taget', 'En cappuccino eller latte till dig'],
      ['many', 'Mjölkdrycker till flera', 'Två eller fler efter varandra'],
      ['filter', 'Även bryggkaffe eller cold brew', 'Pour-over på helgen eller kaffe över is']] },
    q3h: { title: 'Hur mycket vill du styra själv?', opts: [
      ['simple', 'Få knappar', 'Jag smakar mig fram'],
      ['numbers', 'En display med siffrorna', 'Jag ändrar en sak i taget'],
      ['guide', 'En skärm som visar vägen', 'Steg för steg, medan jag lär mig'],
      ['full', 'Allt', 'Gram, grader och tryck']] },
    q2t: { title: 'Hur många dricker kaffe hemma hos er?', opts: [
      ['few', 'En eller två', 'Ett par koppar om dagen'],
      ['many', 'Tre eller fler', 'Eller så har ni ofta gäster']] },
    q3t: { title: 'Hur mycket plats får den ta?', opts: [
      ['narrow', 'Så lite som möjligt', 'En smal maskin, ca 20' + NB + 'cm bred'],
      ['room', 'Den får gärna vara bredare', 'Ca 30' + NB + 'cm går bra']] },
  };
  /* points: question option × machine (§3.2) */
  const POINTS = {
    q2h: { espresso: { core: 2 }, one: { core: 2, brew: 1 }, many: { brew: 2, advanced: 2, expert: 2 }, filter: { expert: 5 } },
    q3h: { simple: { core: 2, brew: 2 }, numbers: { advanced: 3, expert: 2 }, guide: { core: 1, brew: 1, expert: 4 }, full: { advanced: 3, expert: 4 } },
    q2t: { few: { lumina: 2 }, many: { aem: 2 } },
    q3t: { narrow: { lumina: 3 }, room: { aem: 1 } },
  };

  /* ---------- the result copy (§4.2, §4.3) ---------- */
  const TRIAL = 'Inte säker än? Du kan använda den hemma i 30 dagar.';
  const COPY = {
    core: { why: 'Espresso från grunden, i din egen takt.',
      lines: { espresso: ['Espresso och svart kaffe: varmt vatten till americano kommer från ångröret.'], one: ['En mjölkdryck i taget: du brygger espresson och skummar mjölken efteråt.'], simple: ['Få knappar: kvarn och kopp har var sin knapp, och de minns din mängd.'], guide: ['En lugn start: fyra fasta temperaturer och få saker att ställa in.'] },
      budget: 'Under {cap}: samma kvarn och samma PID som Brew och Advanced.',
      defaults: ['Kvarnen är inbyggd, så bönorna mals precis före koppen.', 'Temperaturen hålls stabil med PID, så att kopp nummer två smakar som den första.'],
      good: () => 'Den brygger först och skummar mjölken efteråt.',
      also: { brew: 'Gör ni flera mjölkdrycker efter varandra skummar den mjölk medan espresson rinner.' },
      step: 'samma kvarn och samma PID med få knappar' },
    brew: { why: 'För morgnar då det ska göras mer än en kopp.',
      lines: { many: ['Mjölkdrycker till flera: två värmesystem, så du skummar mjölk medan espresson rinner.'], one: ['En mjölkdryck i taget: mjölken kan skummas medan espresson rinner.'], simple: ['Få knappar: allt sitter på fronten, och det finns inga menyer.'], guide: ['En lugn start: fyra fasta temperaturer och få saker att ställa in.'] },
      budget: 'Under {cap}: samma kvarn och samma PID som Core och Advanced.',
      defaults: ['Kvarnen är inbyggd, så bönorna mals precis före koppen.', 'Temperaturen hålls stabil med PID, så att kopp nummer två smakar som den första.'],
      good: () => 'Fyra fasta temperaturer och ingen display, så du smakar dig fram.',
      also: { core: 'Gör ni en mjölkdryck i taget räcker den: den brygger först och skummar efteråt.', advanced: 'Vill du se siffrorna har den en display med bryggtid och temperatur i steg om 1' + NB + '°C.' },
      step: 'två värmesystem, så den skummar mjölk medan espresson rinner' },
    advanced: { why: 'Du justerar en sak i taget och ser vad det gör med koppen.',
      lines: { numbers: ['En display med siffrorna: den visar bryggtiden medan espresson rinner.', 'Grad för grad: temperaturen i steg om 1' + NB + '°C och en förbryggning som fuktar kaffet först.'], many: ['Mjölkdrycker till flera: den skummar mjölk medan espresson rinner.'], one: ['En mjölkdryck i taget: mjölken kan skummas medan espresson rinner.'], espresso: ['Espresso och svart kaffe: varmt vatten till americano kommer från ett eget utlopp.'], full: ['Det mesta själv: temperatur, förbryggning och mängd efter ditt val.'] },
      budget: 'Under {cap}: display, temperatur i steg om 1' + NB + '°C och eget utlopp för varmt vatten.',
      defaults: ['Temperaturen hålls stabil med PID, så att kopp nummer två smakar som den första.'],
      good: () => 'Det krävs lite övning för att hitta malningen. Displayen visar vad du ändrar.',
      also: { expert: 'Vill du upprepa koppen på grammet har den en våg i kvarnhållaren och sparar dina recept.', brew: 'Den skummar också mjölk medan espresson rinner, men utan display: du smakar dig fram.', core: 'Samma kvarn och samma PID, med få knappar i stället för en display.' },
      step: 'en display med bryggtid och temperatur i steg om 1' + NB + '°C' },
    expert: { why: 'Hjälp på stressiga morgnar och full kontroll på helgen.',
      lines: { guide: ['En skärm som visar vägen: i Simple Mode följer du stegen på skärmen.', 'Hjälp med kvarnen: den kan säga till när kvarnen behöver justeras.'], full: ['Allt: i Expert Mode ställer du in tryck och tid i upp till fyra steg.', 'Gram: vågen i kvarnhållaren visar dosen medan kvarnen går.'], numbers: ['Siffrorna: skärmen visar tryckkurvan, och vågen visar grammen.'], many: ['Mjölken: du väljer 40–⁠70' + NB + '°C, och ångan stannar själv vid den temperaturen.'], one: ['Mjölken: du väljer 40–⁠70' + NB + '°C, och ångan stannar själv vid den temperaturen.'], filter: ['Bryggkaffe och cold brew: egna program, och till pour-over häller den vattnet i steg.'], espresso: ['Espresso och svart kaffe: varmt vatten till americano kommer från ett eget utlopp.'], simple: ['Få tryck: i Simple Mode väljer du drycken och följer stegen.'] },
      defaults: ['Egna recept: spara koppen när den smakar som den ska.', 'Temperaturen hålls stabil med PID, så att kopp nummer två smakar som den första.'],
      good: () => 'Du håller själv kannan, och allt styrs på skärmen.',
      also: { advanced: 'Räcker det med knappar och en display visar den också bryggtid och temperatur.', brew: 'Vill du hellre ha knappar än en skärm skummar den också mjölk medan espresson rinner.', core: 'Vill du hellre lära dig med få knappar hjälper filmerna och serviceteamet dig igång.' },
      step: 'pekskärm, våg i kvarnhållaren och ångrör med temperaturgivare' },
    lumina: { why: 'Var sin kopp med ett tryck, från en maskin som bara är 19,9' + NB + 'cm bred.',
      lines: { few: ['En eller två: 1,2' + NB + 'L vattentank och 100' + NB + 'g bönor i toppen.'], narrow: ['Så lite som möjligt: 19,9' + NB + 'cm bred, 40,3' + NB + 'cm djup och 31,7' + NB + 'cm hög.'] },
      budget: 'Under {cap}: mjölkdrycker med ett tryck, precis som på AEM-101S.',
      defaults: ['Nio drycker på skärmen, från espresso till flat white.', 'Mjölken skummas rakt ner i glaset, och skummet kan göras tjockare eller tunnare.', 'Varje dryck kan anpassas, och maskinen minns den till nästa gång.'],
      good: (a) => (a.q2 === 'many' ? 'Med 1,2' + NB + 'L vatten och 100' + NB + 'g bönor fyller du på oftare när ni är fler.' : 'Bruksanvisningen anger 10' + NB + 'cm fritt runt maskinen.'),
      also: { aem: 'Är ni fler har den 1,8' + NB + 'L vattentank, 160' + NB + 'g bönor och mjölk direkt från förpackningen.' },
      step: 'en bredd på 19,9' + NB + 'cm och mjölkdrycker med ett tryck' },
    aem: { why: 'Åtta kaffedrycker med ett tryck, till hela hushållet.',
      lines: { many: ['Tre eller fler: 1,8' + NB + 'L vattentank och 160' + NB + 'g bönor, så du fyller på mer sällan.'], room: ['Gärna bredare: en stor pekskärm, och de flesta drycker finns också som dubbel.'] },
      defaults: ['Mjölken direkt från förpackningen: sätt i slangen, och välj drycken.', 'Koffeinfritt till en: häll ett mått malet kaffe i tratten.', 'Varje dryck efter er smak: 7–⁠12' + NB + 'g kaffe och 75–⁠95' + NB + '°C.'],
      good: () => 'Den är 28,3' + NB + 'cm bred och 46,3' + NB + 'cm djup. Håll 5' + NB + 'cm fritt till väggen bakom och vid sidan.',
      also: { lumina: 'Är platsen smal är den 19,9' + NB + 'cm bred och gör också mjölkdrycker med ett tryck.' },
      step: '1,8' + NB + 'L vattentank, 160' + NB + 'g bönor och mjölk direkt från förpackningen' },
  };
  const TRUST = {
    hands: ['Prova den hemma i 30 dagar.', 'Passar en annan Aspire bättre kan du byta, och AIVIQ betalar returfrakten vid byte.'],
    touch: '30 dagars returrätt. Du får pengarna tillbaka, även om maskinen är använd, när den är rengjord och skickad i originalförpackningen. Hemprovningen gäller Aspire-serien.',
  };

  /* ---------- state ---------- */
  const SKIP = 'skip';
  let a = {};          /* q1, q2, q3, q4 (q4: a cap in øre, 'any' or 'skip'); the other branch's answers stay in mem */
  const mem = { hands: {}, touch: {} };
  let step = 0;        /* 0..3 = question, 4 = result */
  let moreOpen = false;
  const group = () => (a.q1 === 'touch' ? 'touch' : 'hands');
  const qKey = (i) => (i === 0 ? 'q1' : i === 3 ? 'q4' : 'q' + (i + 1) + (group() === 'touch' ? 't' : 'h'));
  const caps = () => {
    const c = [...new Set(inPlay(group()).map((k) => Math.ceil(DATA[k].price / 100000) * 100000))].sort((x, y) => x - y);
    c.pop();
    return c.slice(0, 3);
  };
  const track = (name, detail) => { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail)); } catch (e) {} };

  /* ---------- scoring (§3.3) ---------- */
  const score = (k) => {
    const g = group();
    let s = 0;
    ['q2', 'q3'].forEach((q) => { const t = POINTS[q + (g === 'touch' ? 't' : 'h')][a[q]]; if (t && t[k]) s += t[k]; });
    return s;
  };
  const compute = () => {
    const g = group();
    const all = inPlay(g);
    const cap = typeof a.q4 === 'number' ? a.q4 : null;
    let under = cap ? all.filter((k) => DATA[k].price <= cap) : all.slice();
    if (!under.length) under = all.slice(0, 1);
    const best = Math.max(...under.map(score));
    const tied = under.filter((k) => score(k) === best);
    const byPrice = (x, y) => DATA[x].price - DATA[y].price;
    const match = cap ? tied.sort(byPrice)[tied.length - 1] : tied.sort(byPrice)[0];
    const pos = (k) => LADDER[g].indexOf(k);
    const nearest = (list) => list.slice().sort((x, y) => Math.abs(pos(x) - pos(match)) - Math.abs(pos(y) - pos(match)) || byPrice(x, y))[0];
    const top = (list) => { const m = Math.max(...list.map(score)); return nearest(list.filter((k) => score(k) === m)); };
    let runner = null;
    let kind = 'also';
    const skipped1 = a.q1 === SKIP || a.q1 === undefined;
    const above = cap ? all.filter((k) => DATA[k].price > cap) : [];
    const better = above.filter((k) => score(k) > best);
    const capDecided = better.length > 0 || (cap && best === 0);
    if (skipped1) {
      const want = a.q2 === 'many' ? 'aem' : 'lumina';
      runner = ok(want) ? want : inPlay('touch')[0] || null;
      kind = 'other';
    }
    if (!runner && better.length) { runner = top(better); kind = 'hint'; }
    if (!runner) {
      const others = under.filter((k) => k !== match);
      if (others.length) runner = top(others);
      else { const up = all.filter((k) => pos(k) > pos(match)); runner = up[0] || all.filter((k) => k !== match)[0] || null; }
    }
    return { match, runner, kind, cap, capDecided, skipped1 };
  };
  const reasons = (r) => {
    const c = COPY[r.match];
    const out = [];
    const add = (t) => { if (t && out.length < 3 && out.indexOf(t) < 0) out.push(t); };
    if (r.skipped1 && DATA[r.match].group === 'hands') add(TRIAL);
    if (r.capDecided && c.budget && r.cap) add(c.budget.replace('{cap}', kr(r.cap)));
    const g = group();
    const given = ['q2', 'q3'].filter((q) => a[q] && a[q] !== SKIP && c.lines[a[q]])
      .map((q, i) => ({ v: a[q], p: ((POINTS[q + (g === 'touch' ? 't' : 'h')][a[q]] || {})[r.match]) || 0, i }))
      .sort((x, y) => y.p - x.p || x.i - y.i);
    given.forEach((x) => add(c.lines[x.v][0]));
    given.forEach((x) => add(c.lines[x.v][1]));
    c.defaults.forEach(add);
    return out;
  };

  /* ---------- drawing ---------- */
  const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.2 4L19 7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  const PEN = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 10h2l5.5-5.5-2-2L2 8z" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
  const label = (i) => {
    const v = a['q' + (i + 1)];
    if (v === undefined || v === SKIP) return null;
    if (i === 3) return v === 'any' ? 'Ingen fast gräns' : 'Upp till ' + kr(v);
    const o = Q[qKey(i)].opts.find((x) => x[0] === v);
    return o ? o[1] : null;
  };
  const drawQuestion = () => {
    const key = qKey(step);
    const isBudget = step === 3;
    const cur = a['q' + (step + 1)];
    let opts;
    let title;
    let sub = '';
    if (isBudget) {
      title = 'Vad får den kosta som mest?';
      opts = caps().map((c) => [c, 'Upp till ' + kr(c), '']).concat([['any', 'Ingen fast gräns', '']]);
      if (group() === 'touch' && inPlay('touch').length) sub = 'Maskinerna med ett tryck kostar från ' + kr(Math.min(...inPlay('touch').map((k) => DATA[k].price))) + '.';
    } else { title = Q[key].title; opts = Q[key].opts; }
    const prog = [0, 1, 2, 3].map((i) => '<i' + (i <= step ? ' class="on"' : '') + '></i>').join('');
    quiz.innerHTML = '<div class="q8-scr"><div class="q8-top">'
      + (step > 0 ? '<button class="q8-back" type="button" data-af-back><span aria-hidden="true">‹</span> Tillbaka</button>' : '')
      + '<span class="eyebrow">Fråga ' + (step + 1) + ' av 4</span><button class="q8-skip" type="button" data-af-skip>Hoppa över</button></div>'
      + '<div class="q8-prog" aria-hidden="true">' + prog + '</div>'
      + '<h3 class="af-q" id="af-q" tabindex="-1">' + esc(title) + '</h3>' + (sub ? '<p class="af-qsub">' + esc(sub) + '</p>' : '')
      + '<div class="af-chips' + (opts.length === 4 ? ' af-chips--4' : '') + '" role="radiogroup" aria-labelledby="af-q">'
      + opts.map((o) => '<button class="q8-chip' + (cur === o[0] ? ' on' : '') + '" type="button" role="radio" aria-checked="' + (cur === o[0]) + '" data-af-opt="' + esc(o[0]) + '">' + esc(o[1]) + (o[2] ? '<small>' + esc(o[2]) + '</small>' : '') + '</button>').join('')
      + '</div>'
      + (step === 0 ? '<div class="af-more"><button class="link af-more__btn" type="button" aria-expanded="' + moreOpen + '" aria-controls="af-more" data-af-more>Vad är skillnaden?</button><p class="af-more__tx" id="af-more"' + (moreOpen ? '' : ' hidden') + '>' + esc(Q.q1.more) + '</p></div>'
        + '<p class="af-empty">Svara på fyra korta frågor, så visar AIVIQ den maskin som passar dina svar, och en till att titta på.</p>' : '')
      + '</div>';
  };
  const drawResult = () => {
    const r = compute();
    const m = DATA[r.match];
    const c = COPY[r.match];
    const chips = [0, 1, 2, 3].map((i) => { const l = label(i); return l ? '<button class="q8-ans" type="button" aria-label="Ändra: ' + esc(l) + '" data-af-edit="' + i + '">' + esc(l) + PEN + '</button>' : ''; }).join('');
    let alt = '';
    if (r.runner) {
      const o = DATA[r.runner];
      const d = o.price - m.price;
      const diff = d > 0 ? ' · +' + kr(d) : d < 0 ? ' · ' + kr(-d) + ' mindre' : '';
      if (r.kind === 'hint') alt = '<b>Passar ännu bättre, över din budget</b> ' + esc(o.name) + ' passar dina svar ännu bättre, men kostar ' + o.priceText + '. Den har ' + COPY[r.runner].step + '.';
      else if (r.kind === 'other') alt = '<b>Vill du hellre ha hela koppen med ett tryck?</b> Se <a class="link" href="' + esc(o.url) + '">' + esc(o.name) + '</a> · ' + o.priceText + '. Den har 30 dagars returrätt, men inte hemprovningen.';
      else alt = '<b>Titta också på <a href="' + esc(o.url) + '">' + esc(o.name) + '</a></b>' + diff + '. ' + (c.also[r.runner] || 'Den har ' + COPY[r.runner].step + '.');
    }
    const trust = m.group === 'hands' ? (r.skipped1 ? TRUST.hands[1] : TRUST.hands.join(' ')) : TRUST.touch;
    quiz.innerHTML = '<div class="af-ans"><span class="eyebrow">Dina svar</span><div class="af-ans__list">' + chips + '</div><button class="link af-ans__reset" type="button" data-af-reset>Börja om</button></div>'
      + '<div class="q8-res" tabindex="-1" data-af-res><span class="q8-tab">Din matchning</span>'
      + '<span class="af-res__img"><img src="' + esc(m.img) + '" alt="' + esc(m.name) + '"></span>'
      + '<div class="af-res__main"><div class="af-res__id"><span class="af-res__name">' + esc(m.name) + '</span><span class="af-res__type">' + esc(m.type) + '</span><span class="af-res__price">' + m.priceText + '<span>' + esc(m.note) + '</span></span></div>'
      + '<p class="af-res__why"><span class="eyebrow">Därför passar den</span>' + esc(c.why) + '</p>'
      + reasons(r).map((t) => '<div class="q8-ck">' + CHECK + '<span>' + esc(t) + '</span></div>').join('')
      + '<p class="af-res__good"><b>Bra att veta:</b> ' + esc(c.good(a)) + '</p></div>'
      + '<div class="af-res__side">' + (alt ? '<p class="af-res__alt">' + alt + '</p>' : '')
      + '<div class="af-res__btns"><a class="btn btn-dark" href="' + esc(m.url) + '">Se ' + esc(m.name) + '</a>' + (m.available && m.variant ? '<button class="btn btn-outline" type="button" data-af-add="' + m.variant + '">Lägg i varukorgen</button>' : '') + '</div>'
      + '<div class="af-res__links"><button class="link" type="button" data-af-edit="3">Ändra svar</button><a class="link" href="#sammenlign-alle-seks">Jämför alla sex <span aria-hidden="true">↓</span></a></div>'
      + '<p class="af-res__trust">' + esc(trust) + '</p>'
      + (m.group === 'touch' ? '<p class="af-res__quiet">Vill du hellre göra espresson själv? Se <a href="#sammenlign-alle-seks" data-af-seg-link="hands">Aspire-serien</a>, som du kan prova hemma i 30 dagar.</p>' : '')
      + '</div></div>';
    mark(r.match);
    showGroup(m.group);
    track('aiviq_finder_result', { path: group(), match: r.match, runner_up: r.runner, budget: r.cap || a.q4 || null, hint: r.kind === 'hint' });
    try { sessionStorage.setItem('aiviq-finder', JSON.stringify({ a, mem })); } catch (e) {}
  };

  /* ---------- the comparison: the ring on the match, the group switch ---------- */
  const TAB = '<span class="q8-cardtab">Din matchning</span>';
  const mark = (key) => {
    root.querySelectorAll('[data-af-card]').forEach((card) => {
      const on = card.getAttribute('data-af-card') === key;
      card.classList.toggle('q8-ring', on);
      const slot = card.querySelector('[data-af-tab]');
      if (!slot) return;
      if (slot.dataset.afRest === undefined) slot.dataset.afRest = slot.innerHTML;
      slot.innerHTML = on ? TAB : slot.dataset.afRest;
      /* phones: the match comes first in its row */
      const rail = card.closest('[data-af-rail]');
      if (rail && on && rail.firstElementChild !== card) rail.insertBefore(card, rail.firstElementChild);
    });
  };
  const showGroup = (g) => {
    root.querySelectorAll('[data-af-group]').forEach((el) => { el.hidden = el.getAttribute('data-af-group') !== g; });
    root.querySelectorAll('[data-af-seg]').forEach((b) => { const on = b.getAttribute('data-af-seg') === g; b.classList.toggle('on', on); b.setAttribute('aria-selected', String(on)); });
  };
  /* a group without machines in the shop has no switch */
  if (!inPlay('touch').length && !Object.keys(DATA).some((k) => DATA[k].group === 'touch' && DATA[k].ok)) { const seg = root.querySelector('.q8-seg'); if (seg) seg.hidden = true; }

  /* ---------- moving on ---------- */
  const draw = (focus) => {
    if (step >= 4) drawResult(); else drawQuestion();
    if (focus) { const el = quiz.querySelector(step >= 4 ? '[data-af-res]' : '#af-q'); if (el) el.focus({ preventScroll: true }); }
  };
  const next = () => {
    /* go to the first question that has no answer yet (after an edit the rest is kept) */
    let i = 0;
    while (i < 4 && a['q' + (i + 1)] !== undefined) i++;
    step = i;
    draw(true);
    if (step >= 4) {
      const res = quiz.querySelector('[data-af-res]');
      const top = quiz.getBoundingClientRect().top;
      if (res && (top < 0 || top > window.innerHeight * 0.6)) window.scrollTo({ top: Math.max(0, top + window.scrollY - 120), behavior: 'auto' });
    }
  };
  const answer = (v) => {
    const i = step;
    const key = 'q' + (i + 1);
    if (i === 0) {
      const before = group();
      mem[before] = { q2: a.q2, q3: a.q3, q4: a.q4 };
      a.q1 = v;
      const now = group();
      if (now !== before) { a.q2 = mem[now].q2; a.q3 = mem[now].q3; a.q4 = mem[now].q4; }
    } else a[key] = i === 3 && v !== 'any' && v !== SKIP ? Number(v) : v;
    /* a cap that no longer exists in this branch is asked again */
    if (typeof a.q4 === 'number' && caps().indexOf(a.q4) < 0) a.q4 = undefined;
    track('aiviq_finder_answer', { q: i + 1, value: v });
    next();
  };
  quiz.addEventListener('click', (e) => {
    const t = e.target.closest('button, a');
    if (!t || !quiz.contains(t)) return;
    if (t.hasAttribute('data-af-opt')) {
      quiz.querySelectorAll('[data-af-opt]').forEach((b) => { const on = b === t; b.classList.toggle('on', on); b.setAttribute('aria-checked', String(on)); });
      const v = t.getAttribute('data-af-opt');
      setTimeout(() => answer(v), 260);
    } else if (t.hasAttribute('data-af-skip')) answer(SKIP);
    else if (t.hasAttribute('data-af-back')) { step = Math.max(0, step - 1); draw(true); }
    else if (t.hasAttribute('data-af-more')) { moreOpen = !moreOpen; t.setAttribute('aria-expanded', String(moreOpen)); quiz.querySelector('#af-more').hidden = !moreOpen; }
    else if (t.hasAttribute('data-af-edit')) { step = Number(t.getAttribute('data-af-edit')); a['q' + (step + 1)] = a['q' + (step + 1)] === SKIP ? undefined : a['q' + (step + 1)]; drawQuestion(); const h = quiz.querySelector('#af-q'); if (h) h.focus({ preventScroll: true }); }
    else if (t.hasAttribute('data-af-reset')) { a = {}; mem.hands = {}; mem.touch = {}; step = 0; mark(null); showGroup('hands'); try { sessionStorage.removeItem('aiviq-finder'); } catch (x) {} draw(true); }
    else if (t.hasAttribute('data-af-seg-link')) showGroup(t.getAttribute('data-af-seg-link'));
    else if (t.hasAttribute('data-af-add')) addToCart(t);
  });
  /* editing a question that already has an answer: picking again returns to the result */
  root.querySelectorAll('[data-af-seg]').forEach((b) => b.addEventListener('click', () => showGroup(b.getAttribute('data-af-seg'))));

  /* »Læg i kurv«: the cart drawer opens as on the rest of the site */
  const addToCart = async (btn) => {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-af-add')), quantity: 1 }] }),
      });
      const data = await res.json();
      if (!res.ok) throw data;
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data, addToCartBtn: btn } }));
    } catch (x) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', { bubbles: true, detail: { errorMessage: x && x.description } }));
    } finally { btn.removeAttribute('aria-busy'); }
  };

  /* FAQ under the comparison */
  root.querySelectorAll('.af-faq .faq').forEach((btn) => {
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = !open;
      const path = btn.querySelector('svg path');
      if (path) path.setAttribute('d', open ? 'M2 8h12' : 'M8 2v12M2 8h12');
    });
  });

  /* start: a result from this visit is shown again (back from a product page) */
  try {
    const saved = JSON.parse(sessionStorage.getItem('aiviq-finder') || 'null');
    if (saved && saved.a) { a = saved.a; Object.assign(mem, saved.mem || {}); if (typeof a.q4 === 'number' && caps().indexOf(a.q4) < 0) a.q4 = 'any'; step = 4; }
  } catch (e) {}
  if (step >= 4 && [1, 2, 3, 4].every((n) => a['q' + n] !== undefined)) drawResult(); else { step = 0; drawQuestion(); }
})();
